<template>
    <div class="monthwrap">
        <div class="monthTitle">
            {{monthTitle}}
        </div>
        <div class="monthView">
            <div v-for="d in 7" :key="d" class="dayTitle">
                {{dayTitle(d)}}
            </div>
            <div v-for="d in monthDays" :key="`${d.date.month}-${d.date.day}`" class="day"
                    :class="{thisMonth: d.thisMonth, today: d.today, weekend: d.weekend}" >
                <span class="date" @click="selectDate(d.date)">{{d.date.day}}</span>
                <div v-for="e in d.events" :key="`${e.id}-${e.recurId}}`" class="event" :style="style[e.calid]"
                @click="selectEvent(e)">
                    <span class="time" v-if="!e.allday">{{e.startDateTime.toFormat('HH:mm')}}</span>
                    <span class="summary">{{e.summary}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { DateTime, Interval } from 'luxon';

export default {
  name: 'calendarMonth',
  props: {
    events: Array,
    startDate: Object
  },
  methods: {
    dayTitle(dow) {
      return this.monthDays[dow - 1].date.toLocaleString({ weekday: 'short' });
    },
    selectDate(date) {
      this.$router.push(`/calendar/day/${date.toFormat('yyyyMMdd')}`);
    },
    selectEvent(event) {
      if (event.recurrence) {
        this.$router.push(
          { name: 'calendarEditRecurEvent',
            params: Object.assign({}, this.$route.params, { eventId: event.id, recurId: event.recurId }) });
      } else {
        this.$router.push(
          { name: 'calendarEvent', params: Object.assign({}, this.$route.params, { eventId: event.id }) });
      }
    }
  },
  computed: {
    monthTitle() {
      return this.startDate.toLocaleString({ month: 'long', year: 'numeric' });
    },
    monthDays() {
      const startDate = this.startDate.startOf('week');
      const today = DateTime.local();
      let days = [];
      for (let i = 0; i < 42; i++) {
        const thisDate = startDate.plus({ days: i });
        const thisDay = Interval.fromDateTimes(thisDate, thisDate.endOf('day'));
        days.push({
          date: thisDate,
          thisMonth: (thisDate.month === this.startDate.month),
          today: thisDate.hasSame(today, 'day'),
          weekend: thisDate.weekday >= 6,
          events: this.events.filter(e => {
            return Interval.fromDateTimes(e.startDateTime, e.endDateTime).overlaps(thisDay);
          }).sort((a, b) => {
            if (a.startDateTime < b.startDateTime) {
              return -1;
            } else if (a.startDateTime > b.startDateTime) {
              return 1;
            } else {
              return a.summary.localeCompare(b.summary, 'en', { sensitivity: 'base' });
            }
          })
        });
      }

      return days;
    },
    style() {
      return this.$store.getters.calendarEventStyles;
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .monthwrap {
        display: flex;
        flex-direction: column;
        height: 100%;
        .monthView {
            flex: 1;
            width: 100%;
            overflow-x: hidden;
            overflow-y: hidden;

            display: grid;
            grid-template-columns: repeat(7, 1fr);
            grid-template-rows: 1.5rem repeat(6, 1fr);

            .dayTitle {
                text-align: center;
                font-weight: bold;
            }

            .day {
                overflow: hidden;
                overflow-y: auto;
                color: $calendar-month-notthismonth-text;
                background-color: $calendar-month-notthismonth-background;
                &.thisMonth {
                    color: $black;
                    background-color: white;
                }
                &.today {
                    background-color: $calendar-month-today-background;
                }
                &.weekend {
                    background-color: $calendar-month-weekend-background;
                }
                font-size: 0.7rem;
                .date {
                    font-weight: bold;
                    cursor: pointer;
                }
                .event {
                    .time {
                        margin-right: 3px;
                    }
                    color: $black;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    cursor: pointer;
                    background-color: $calendar-month-event-background;
                    margin: 1px;
                    padding: 1px;
                    border-radius: 1px;
                }

            }

        }
        .monthTitle {
            flex: 0 0 auto;
            text-align: center;
            font-weight: bold;
        }
    }

</style>
